// extracted by mini-css-extract-plugin
module.exports = {"ToggleSwitch":"ToggleSwitch_ToggleSwitch__38vbK","icon":"ToggleSwitch_icon__B5FuS"};